$(document).ready(function(){
	
  $('a.button').on('click', function(e){
    if(typeof $(this).data('pt_cta_id') != "undefined" && $(this).data('pt_cta_id') != "") {
      
      e.preventDefault();      
      const pt_cta_id = $(this).data('pt_cta_id');
        pSendGAEvent('pt_cta_click', { pt_cta_id: pt_cta_id}, 'to comparison page send event gone wrong');
      window.location = $(this).attr('href');
    }
        
  });
  
  $('.slideToggleContainer').each(function(){
    $(this).find('.left').addClass('act');
  });
  
  $('.slideToggleContainer input:checkbox').on('change', function(){
    updateDetailViews($(this).closest('.slideToggleContainer').data('tocomptoggle'));
  });
  
  $('.slideToggleContainer .left, .slideToggleContainer .right').on('click', function(){
    $(this).closest('.slideToggleContainer').find('input:checkbox').trigger('click');
  });
  
  
  $('.to-comparison-topic .what span').on('click', function(e){
    
    $main = $(this).closest('.to-comparison-topic');
    $sub = $(this).closest('.comparing');
    
    if($(this).parent().hasClass('open')) {
      
      $(this).parent().removeClass('open');
      $sub.find('.content').removeClass('open');
      
    } else {
     
      $main.find('.content').removeClass('open');
      $main.find('.what').removeClass('open');
      
      $sub.find('.content').addClass('open');
      $(this).parent().addClass('open'); 
      
      var link = $(this).closest('.comparing').offset().top;
      var win = $(window).scrollTop()+$('.header-container').height();
      
      if(link < win) {
        $(window).scrollTop(link-$('.header-container').height());
      }
      
    }
    
    if( ($main.find('.open').length != $main.find('.comparing').length) &&
        $main.find('input:checkbox').is(':checked')
      ) {
      $main.find('.right').removeClass('act');
      $main.find('.left').addClass('act');
      $main.find('input:checkbox').prop('checked', false);
    }
  });
  
  $('.to-comp-burger').on('click', function (){
    $(this).toggleClass('open');
    $('.to-comp-menu').toggleClass('open');
    
    if($('.to-comp-menu').hasClass('open')) {
      $('.to-comp-menu').css('margin-top', 'calc(-1 * (116px + '+$('.to-comp-menu').outerHeight()+'px))');
      $('.to-comp-menu').css('top', "calc(100vh - "+$('.to-comp-menu').outerHeight()+"px - 76px)");
    } else {
      $('.to-comp-menu').css('margin-top', 'calc(-1 * ('+$('.to-comp-menu').outerHeight()+'px))');
    }
    
  });
  
});

function updateDetailViews($type) {
  $container = $('.slideToggleContainer[data-tocomptoggle="'+$type+'"]');
  $input = $container.find('input:checkbox');
  
  $container.find('.left').removeClass('act');
  $container.find('.right').removeClass('act');
      
  if($input.is(':checked')) {
    $container.find('.right').addClass('act');
    handleAllDetailsOfType($type, true);
  } else {
    $container.find('.left').addClass('act');
    handleAllDetailsOfType($type, false);
  } 
  

}

function handleAllDetailsOfType ($type, $show) {

  $container = $('.to-comparison-topic[data-tocompcontainer="'+$type+'"]');
  
  if($show) {
    $container.find('.what').addClass('open');
    $container.find('.content').addClass('open');
  } else {
    $container.find('.what').removeClass('open');
    $container.find('.content').removeClass('open');
  }
  
}
